module.exports = __webpack_public_path__ + "9fcb3ea3f32c5e35859479d0acabb4e2.pdf";